import React, { FC } from 'react'
import RoutableNotEditableLink from '../RoutableNotEditableLink'
import { TCTAWithArrow } from './index.types'
import './styles.scss'

const CTAWithArrow: FC<TCTAWithArrow> = ({ href, text, color }) => (
  <div className="cta-with-arrow">
    {color && (
      <RoutableNotEditableLink href={href}>
        {text}
        <span className="cta-with-arrow__text">
          <pfe-icon
            icon="cnh-arrow-forward"
            size={'24'}
            color={color}
            class="cta-with-arrow__icon"
          />
        </span>
      </RoutableNotEditableLink>
    )}
    {!color && (
      <RoutableNotEditableLink href={href}>
        {text}
        <span className="cta-with-arrow__text">
          <pfe-icon
            icon="cnh-arrow-forward"
            size={'24'}
            color={'base'}
            class="cta-with-arrow__icon"
          />
        </span>
      </RoutableNotEditableLink>
    )}
  </div>
)

export default CTAWithArrow
